import React from 'react';
import type { FC } from 'react';
import { Text } from '../components/Text.js';

export const QuestionMarkIcon: FC = () => {
  return <Text>?</Text>;
};
